import customAxios from "../index";

export const getAdminProfile = (params: { timezone: string }) => {
    return customAxios({
        method: "GET",
        url: "/admin/profile",
        params,
    });
};

export const updateAdminProfile = (data: any) => {
    return customAxios({
        method: "PUT",
        url: "/admin/profile",
        data,
    });
};

export const uploadAdminProfilePhoto = (formData: FormData) => {
    return customAxios({
        method: "POST",
        url: "/admin/profile/photo",
        data: formData,
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

export const deleteAdminProfilePhoto = () => {
    return customAxios({
        method: "DELETE",
        url: "/admin/profile/photo",
    });
};

export const adminChangePassword = (data: URLSearchParams) => {
    return customAxios({
        method: "POST",
        url: "/auth/admin/change-password",
        data,
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
    });
};
